import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);

export const joinWaitlist = (payload) =>
  api.post("/waitlist/phantom-chat", payload).then((r) => r.data);

export const createOrder = (payload) => api.post("/orders", payload).then((r) => r.data);

export const getOrder = (orderNumber) =>
  api.get(`/orders/${orderNumber}`).then((r) => r.data);

export const markOrderPaid = (orderNumber) =>
  api.post(`/orders/${orderNumber}/mark-paid`).then((r) => r.data);

export const getExchangeRates = () =>
  api.get("/exchange-rates").then((r) => r.data);

// -------- Stripe (card payment) --------
export const createStripeCheckout = (payload) =>
  api.post("/payments/checkout", payload).then((r) => r.data);

export const getPaymentStatus = (sessionId) =>
  api.get(`/payments/status/${sessionId}`).then((r) => r.data);

// -------- Admin --------
const adminHeaders = (token) => ({ headers: { "X-Admin-Token": token } });

export const adminLogin = (token) =>
  api.post("/admin/login", { token }).then((r) => r.data);

export const adminGetStats = (token) =>
  api.get("/admin/stats", adminHeaders(token)).then((r) => r.data);

export const adminGetOrders = (token) =>
  api.get("/admin/orders", adminHeaders(token)).then((r) => r.data);

export const adminUpdateOrderStatus = (token, orderNumber, patch) =>
  api
    .patch(`/admin/orders/${orderNumber}`, patch, adminHeaders(token))
    .then((r) => r.data);

export const adminGetContacts = (token) =>
  api.get("/admin/contacts", adminHeaders(token)).then((r) => r.data);

export const adminUpdateContactHandled = (token, contactId, handled) =>
  api
    .patch(`/admin/contacts/${contactId}`, { handled }, adminHeaders(token))
    .then((r) => r.data);

export const adminGetWaitlist = (token) =>
  api.get("/admin/waitlist", adminHeaders(token)).then((r) => r.data);
